import styled from "styled-components";

export const NFPageContainer = styled.div`
  width: 100%;
  height: 100vh;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  gap: 40px;

  @media (min-width: 428px) {
    max-width: 454px;
    gap: 50px;
    margin: 0 auto;
  }

  @media (min-width: 1024px) {
    max-width: 560px;
    gap: 40px;
  }

  @media (min-width: 1440px) {
    max-width: 660px;
    gap: 80px;
  }
`;

export const NFPageLogo = styled.h1`
  font-size: 20px;
  font-weight: 500;
  line-height: 1.2;
  color: #000;

  &:hover {
    cursor: pointer;
  }

  @media (min-width: 428px) {
    font-size: 24px;
    font-weight: 500;
    line-height: 1.2;
  }

  @media (min-width: 744px) {
    font-size: 32px;
    font-weight: 500;
    line-height: 1.18;
  }

  @media (min-width: 1024px) {
    font-size: 36px;
    font-weight: 500;
    line-height: 1.19;
  }
`;

export const NFPageLogoColor = styled.span`
  color: #1ac63f;
`;

export const NFPageText = styled.p`
  font-size: 20px;
  font-weight: 500;
  line-height: 1.2;
  color: #585858;

  @media (min-width: 428px) {
    font-size: 24px;
    font-weight: 500;
    line-height: 1.2;
  }

  @media (min-width: 744px) {
    font-size: 24px;
    font-weight: 500;
    line-height: 1.2;
  }

  @media (min-width: 1024px) {
    font-size: 32px;
    font-weight: 500;
    line-height: 1.18;
  }

  @media (min-width: 1440px) {
    font-size: 36px;
    font-weight: 500;
    line-height: 1.19;
  }
`;

export const NFPageError = styled.h2`
  font-size: 20px;
  font-weight: 500;
  line-height: 1.2;

  @media (min-width: 428px) {
    font-size: 24px;
    font-weight: 500;
    line-height: 1.2;
  }

  @media (min-width: 744px) {
    font-size: 24px;
    font-weight: 500;
    line-height: 1.2;
  }

  @media (min-width: 1024px) {
    font-size: 32px;
    font-weight: 500;
    line-height: 1.18;
  }

  @media (min-width: 1440px) {
    font-size: 36px;
    font-weight: 500;
    line-height: 1.19;
  }
`;
